(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      
      // Check if transparency should be enabled
      this.isTransparentEnabled = document.body.classList.contains('transparent-header-enabled');

      // Initial scroll check - this is important for page load
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.isTransparentEnabled) {
        // Use getScrollThreshold method for consistency
        const threshold = this.getScrollThreshold();
        if (scrollTop > threshold) {
          document.body.classList.add('scrolled-header');
          // Apply the transition property for smooth color changes
          this.header.style.transition = 'background-color 0.3s ease, color 0.3s ease, fill 0.3s ease';
        } else {
          document.body.classList.remove('scrolled-header');
        }
      }

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }
    
    getScrollThreshold() {
      // Get threshold from CSS variable, fallback to computed header height or 60px
      if (!this.cachedScrollThreshold) {
        const cssThreshold = getComputedStyle(document.documentElement)
          .getPropertyValue('--header-scroll-threshold');
        this.cachedScrollThreshold = cssThreshold
          ? parseInt(cssThreshold)
          : this.header.offsetHeight || 60;
      }
      return this.cachedScrollThreshold;
    }

    handleTransparentHeader() {
      // Only handle transparency if enabled
      if (!this.isTransparentEnabled) return;

      // Check scroll position and update header state
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollThreshold = this.getScrollThreshold();

      // Store current state to avoid unnecessary DOM operations
      const isCurrentlyScrolled = document.body.classList.contains('scrolled-header');

      if (scrollTop <= scrollThreshold) {
        if (isCurrentlyScrolled) {
          document.body.classList.remove('scrolled-header');
          // Remove any inline styles that might have been added
          requestAnimationFrame(() => {
            this.header.style.removeProperty('transition');
          });
        }
      } else {
        if (!isCurrentlyScrolled) {
          // Add smooth transition when scrolling - use requestAnimationFrame for better performance
          requestAnimationFrame(() => {
            this.header.style.transition = 'background-color 0.3s ease, color 0.3s ease, fill 0.3s ease';
            document.body.classList.add('scrolled-header');
          });
        }
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      
      // Handle transparent header state
      this.handleTransparentHeader();

      // Handle sticky behavior
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
